import { Component } from '@angular/core';
import { NotificationService } from '@src/app/services/notification/notification.service';
import { NotificationCardType } from '@src/app/components/notification-card/notification-card.type';
import { Icon, iconSource } from '@src/app/library/components/icon';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-demo',
  templateUrl: './demo.component.html',
  styleUrls: ['./demo.component.scss'],
  standalone: false,
})
export class DemoComponent {
  public buttonDisabled: boolean = false;
  public maxLength = 40;
  public submittedAtLeastOnce: boolean = false;

  // Construct all icons
  public allIcons: string[][] = Object.values(Icon).map(i => [i, iconSource(i)]);

  form: FormGroup = this._formBuilder.group({
    email: ['', [Validators.email, Validators.maxLength(this.maxLength), Validators.required]],
    name: ['', [Validators.maxLength(this.maxLength), Validators.required]],
    userAgreement: [false, [Validators.requiredTrue]],
  });

  // convenience getter for easy access to form fields
  get f(): FormGroup['controls'] {
    return this.form.controls;
  }

  public allEnumIcons = Icon;
  public notificationCardType = NotificationCardType;

  // Some icons for displaying
  public icons = [
    { name: 'cart', icon: Icon.edit, disabled: false },
    { name: 'dots', icon: Icon.previewmode, disabled: false },
    { name: 'revert', icon: Icon.revert, disabled: false },
  ];

  constructor(
    private _notificationService: NotificationService,
    private _formBuilder: FormBuilder
  ) {
  }

  public buttonClick(): void {
    this.buttonDisabled = true;
    setTimeout(() => this.buttonDisabled = false, 5000);
  }

  public demoNotification(message: string, icon: Icon, cardType: NotificationCardType): void {
    this._notificationService.showNotification(message, icon, cardType);
  }

  public toggleSwitch(newIndex: number): void {
  }

  public save(): void {
    this.submittedAtLeastOnce = true;
  }
}
